import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCustomerOrderDetails(orderId) {
  const response = await $.soap({
    body: {
      GetCustomerOrderDetails: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..ID',
        orderFormTypeId: '$..OrderFormTypeID',
        externalUserID: '$..ExternalUserID',
        commandId: '$..CommandID',
        crsOwner: '$..CRSOwner',
        epcOwner: '$..EPCInternalUserID',
        statusId: '$..StatusID',
        orderPackageId: '$..OrderPackageID',
        createdBy: '$..CreatedBy',
        createdOn: '$..CreatedOn',
        updatedOn: '$..UpdatedOn',
        updatedBy: '$..UpdatedBy',
        submittedOn: '$..SubmittedOn',
        submittedBy: '$..SubmittedBy',
        isClosed: '$..IsClosed',
        approvedOn: '$..ApprovedOn',
        expectedDeliveryDate: '$..ExpectedDeliveryDate',
        crsDecisionExplanation: '$..CRSDecisionExplanation',
        isNewContract: '$..IsNewContract',
        replacementPIINSPIIN: '$..ReplacementPIINSPIIN',
        numReplacementDevices: '$..NumReplacementDevices',
        popDate: '$..POPDate',
        customerContactDateReq: '$..CustomerContactDateReq',
        customerContactedOn: '$..CustomerContactedOn',
        submissionToEPCDateReq: '$..SubmissionToEPCDateReq',
        trackerNumber: '$..TrackerNumber',
        commandName: '$..CommandName',
        dodac: '$..DODAC',
        addressId: '$..AdderssId',
        externalOrderStatus: '$..ExternalOrderStatus',
        internalOrderStatus: '$..InternalOrderStatus',
        formCode: '$..FormCode',
        formName: '$..FormName',
        orderPackageSubmittedOn: '$..OrderPackageSubmittedOn',
        externalUserFirstName: '$..ExternalUserFirstName',
        externalUserLastName: '$..ExternalUserLastName',
        externalUserEmail: '$..ExternalUserEmail',
        externalUserTelephone: '$..ExternalUserTelephone',
        regionGroup: '$..RegionGroup',
        branchName: '$..BranchName'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
